import React from 'react';
import {change as changeFieldValue, Field, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import $ from 'jquery';
import Autorizacao, { validaPerfis } from '../../security/Autorizacao';
import {
    getGestorEmpresa, 
    getOperadorEmpresa, 
    getPerfisVendedores,     
    getPerfisAlterarDadosPassageiro,
    PERFIL_ADMIN
} from '../../security/securityContext';
import informarComprovantePagamento from '../../actions/forma-pagamento/informarComprovantePagamento';
import {
    apenasLetra,
  apenasNumero,
  data,
  dataValidade,
  idadeMinCriancaColo,
  idadeMinIdoso,
  renderField,
  renderFieldCheck,
  renderFieldCpf,
  renderFieldDataNascimento,
  renderFieldMoeda,
  renderFieldTelefone,
  required,
  requiredSelect,
  validarCPF,
  validarRG
} from '../../util/inputs';
import alterarCriacaColo from '../../actions/pedido/alterarCriacaColo';
import alterarDadosPassageiros from '../../actions/passageiro/alterarDadosPassageiros';
import buscarPassageiroPorCpf from '../../actions/passageiro/buscarPassageiroPorCpf';
import {showSuccessMsg} from '../../util/messagesUtil';
import Select from 'react-select';
import { paisesDDI } from '../../util/constantsUtil';

export class ModalAlteracaoDadosPassageiro extends React.Component {
    constructor(props) {
        super(props);
        this.submit = this.submit.bind(this);        
    }

    exibirComboDDI(event) {        
        return (
            <div>
                <Select
                    {...event.input}
                    options={paisesDDI.map(elemento => ({
                      label: `${elemento.pais} ${elemento.ddi}`,
                      value: elemento.id
                    }))}
                    onChange={(value) => {                    
                      this.props.adicionarValoresDdiPassageiro(event.passageiro, value)                      
                      event.input.onChange(value);                    
                    }}
                />
                {event.meta.touched
                && (event.meta.error && <span style={{color: 'red'}}>{event.meta.error}</span>)}
          </div>
        )    
    }

    fecharModal() {
        $('#modalAlterarDadosPassageiro')
            .modal('hide');
        $('#modalAlterarDadosPassageiro')
            .hide();
        $('.modal-backdrop')
            .hide();
        this.props.reset('formGerenciarPedido')
    }

    exibirCamposAdicionaisDesconto(reserva) {
        if (reserva.passageiroDto.tipoEmissao === undefined) {
            return ''
        }
        if (reserva.passageiroDto.tipoEmissao === 'ID_JOVEM_50'
            || reserva.passageiroDto.tipoEmissao === 'ID_JOVEM_100') {
            return (
                <div>
                    <div className="form-row mt-1">
                        <div className="col-sm-6 col-md-4">
                            <Field name={`nisPassageiro${reserva.passageiroDto.id}`} type="text" max={10}
                                   component={renderField}
                                   label='NIS'
                                   validate={[required]}
                                   css="form-control"/>
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <Field name={`validade${reserva.passageiroDto.id}`} type="text" max={15}
                                   component={renderFieldDataNascimento}
                                   label='Validade'
                                   validate={[data, dataValidade, required]}
                                   css="form-control"/>
                        </div>
                    </div>
                </div>
            )
        }
        if (reserva.passageiroDto.tipoEmissao === 'IDOSO_100'
            || reserva.passageiroDto.tipoEmissao === 'IDOSO_50') {
            return (
                <div>
                    <div className="form-row mt-1">
                        <div className="col-sm-6 col-md-4">
                            <Field name={`matriculaPassageiro${reserva.passageiroDto.id}`} type="text" max={80}
                                   component={renderField}
                                   label='Matricula'
                                   validate={[required]}
                                   css="form-control"/>
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <Field name={`rendaPassageiro${reserva.passageiroDto.id}`} type="text" max={10}
                                   component={renderFieldMoeda}
                                   label='Renda R$'
                                   validate={[required]}
                                   css="form-control"/>
                        </div>
                    </div>
                </div>
            )
        }
        if (reserva.passageiroDto.tipoEmissao === 'DEFICIENTE') {
            return (
                <div>
                    <div className="form-row mt-1">
                        <div className="col-sm-6 col-md-4">
                            <Field name={`numeroDeficientePassageiro${reserva.passageiroDto.id}`} type="text" max={10}
                                   component={renderField}
                                   label='Número'
                                   validate={[required]}
                                   css="form-control"/>
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <Field name={`validade${reserva.passageiroDto.id}`} type="text" max={15}
                                   component={renderFieldDataNascimento}
                                   label='Validade'
                                   validate={[data, dataValidade, required]}
                                   css="form-control"/>
                        </div>
                    </div>
                </div>
            )
        }
        if (reserva.passageiroDto.tipoEmissao === 'P_LIVRE_POLICIAL_AUDITOR') {
            return (
                <div>
                    <div className="form-row mt-1">
                        <div className="col-sm-6 col-md-4">
                            <Field name={`cargoProfissaoPassageiro${reserva.passageiroDto.id}`} type="text" max={10}
                                   component={renderField}
                                   label='Cargo/Profissão'
                                   validate={[required]}
                                   css="form-control"/>
                        </div>
                    </div>
                </div>
            )
        }
        return ''
    }

    submit(values) {
        const parametros = [];
        this.props.pedido.reservas.forEach((it) => {
            const passageiro = it.passageiroDto;
            const pais = paisesDDI.find(it => it.id === values[`ddi${passageiro.id}`].value)
            parametros.push({
                id: passageiro.id,
                nome: values[`nomePassageiro${passageiro.id}`],
                documentoComFoto: values[`numeroDocumentoFoto${passageiro.id}`],
                cpfPassageiro: values[`numeroCpfPassageiro${passageiro.id}`],
                dtNascimento: values[`dtNascimentoPassageiro${passageiro.id}`],
                crianca: values[`criancaColo${passageiro.id}`] ? {
                    nome: values[`nomeCrianca${passageiro.id}`],
                    dtNascimentoCrianca: values[`dtNascimentoCrianca${passageiro.id}`],
                    cpfCrianca: values[`cpfCrianca${passageiro.id}`],
                    documentoCriacaComFoto: values[`documentoCriancaFoto${passageiro.id}`],
                } : null,
                nis: values[`nisPassageiro${passageiro.id}`],
                validade: values[`validade${passageiro.id}`],
                renda: values[`rendaPassageiro${passageiro.id}`],
                cargoProfissao: values[`cargoProfissaoPassageiro${passageiro.id}`],
                numeroDeficiente: values[`numeroDeficientePassageiro${passageiro.id}`],
                ddi: pais.ddi,
                siglaPais: pais.sigla,
                telefone: values[`telefone${passageiro.id}`],
                matricula: values[`matriculaPassageiro${passageiro.id}`],
            })
        });
        this.props.alterarDadosPassageiros(this.props.empresaSelecionada.id, this.props.pedido.id, parametros)
            .then(() => {                
                if (this.possuiPermicaoParaEditarDadosDoPassageiro()) {
                    showSuccessMsg('Passageiros alterados com sucesso');
                } else if (this.seNaoPossuiPermicaoParaEditarDadosDoPassageiro() && this.props.pedido.reservas.filter(it => it.passageiroDto.criancaDto != null).length > 0) {
                    showSuccessMsg('Os dados de criança de colo foi salvo com sucesso');
                }
                this.fecharModal();
                this.props.buscarPedidos();
            })
    }

    limparFormulario() {
        this.props.limparValoresDdiPassageiro();
        this.props.reset('formAlterarDadosPassageiroPedido');
    }

    // eslint-disable-next-line class-methods-use-this
    exibirBotoesVendedor(invalid, submitting) {
        return (
            <div className="modal-footer">
                <Autorizacao perfisPermitidos={[
                    getGestorEmpresa(this.props.empresaSelecionada.id),
                    getOperadorEmpresa(this.props.empresaSelecionada.id),
                    ...getPerfisVendedores(this.props.empresaSelecionada.id),
                ]}>
                    <button type="submit" className="btn btn-laranja" id="btn-confirmar-acesso-autos"
                            disabled={invalid || submitting}>
                        ENVIAR
                    </button>
                </Autorizacao>
            </div>)
    }

    alterarCriancaColo(reserva) {
        this.props.alterarCriacaColo(this.props.pedido, reserva);
    }

    buscarUsuarioPorCpf(event, reserva) {
        this.props.buscarPassageiroPorCpf(apenasNumero(event.target.value)).then((resp) => {
            if (resp.payload.status === 200) {
                const passageiro = resp.payload.data;
                this.props.changeFieldValue('formAlterarDadosPassageiroPedido',
                    `nomePassageiro${reserva.passageiroDto.id}`, passageiro.nome);
                this.props.changeFieldValue('formAlterarDadosPassageiroPedido',
                    `numeroCpfPassageiro${reserva.passageiroDto.id}`, passageiro.cpfPassageiro);
                this.props.changeFieldValue('formAlterarDadosPassageiroPedido',
                    `dtNascimentoPassageiro${reserva.passageiroDto.id}`, passageiro.dtNascimento);
                this.props.changeFieldValue('formAlterarDadosPassageiroPedido',
                    `numeroDocumentoFoto${reserva.passageiroDto.id}`, passageiro.documentoComFoto);
                this.props.changeFieldValue('formAlterarDadosPassageiroPedido',
                    `telefone${reserva.passageiroDto.id}`, passageiro.telefone);
                this.props.changeFieldValue('formAlterarDadosPassageiroPedido',
                    `nisPassageiro${reserva.passageiroDto.id}`, passageiro.nis);
                this.props.changeFieldValue('formAlterarDadosPassageiroPedido',
                    `validadeNisPassageiro${reserva.passageiroDto.id}`, passageiro.validade);
                this.props.changeFieldValue('formAlterarDadosPassageiroPedido',
                    `matriculaPassageiro${reserva.passageiroDto.id}`, passageiro.matricula);
                this.props.changeFieldValue('formAlterarDadosPassageiroPedido',
                    `rendaPassageiro${reserva.passageiroDto.id}`, passageiro.renda);
                this.props.changeFieldValue('formAlterarDadosPassageiroPedido',
                    `numeroDeficientePassageiro${reserva.passageiroDto.id}`, passageiro.numeroDeficiente);
                this.props.changeFieldValue('formAlterarDadosPassageiroPedido',
                    `validade${reserva.passageiroDto.id}`, passageiro.validade);
                this.props.changeFieldValue('formAlterarDadosPassageiroPedido',
                    `cargoProfissaoPassageiro${reserva.passageiroDto.id}`, passageiro.cargoProfissao);
                const pais = paisesDDI.find(it => it.sigla === reserva.passageiroDto.siglaPais)
                this.props.changeFieldValue('formAlterarDadosPassageiroPedido',
                      `ddi${reserva.passageiroDto.id}`, {label: `${pais.pais} ${pais.ddi}`, value: pais.id});
                if (passageiro.criancaDto) {
                    this.props.changeFieldValue('formAlterarDadosPassageiroPedido',
                        `nomeCrianca${reserva.passageiroDto.id}`, passageiro.criancaDto.nome);
                    this.props.changeFieldValue('formAlterarDadosPassageiroPedido',
                        `cpfCrianca${reserva.passageiroDto.id}`, passageiro.criancaDto.cpfCrianca);
                    this.props.changeFieldValue('formAlterarDadosPassageiroPedido',
                        `dtNascimentoCrianca${reserva.passageiroDto.id}`, passageiro.criancaDto.dtNascimentoCrianca);
                    this.props.changeFieldValue('formAlterarDadosPassageiroPedido',
                        `documentoCriancaFoto${reserva.passageiroDto.id}`, passageiro.criancaDto.documentoCriacaComFoto);
                    this.props.changeFieldValue('formAlterarDadosPassageiroPedido',
                        `criancaColo${reserva.passageiroDto.id}`, true);
                }
            }
        })
    }

    possuiPermicaoParaEditarDadosDoPassageiro() {
        return validaPerfis(getPerfisAlterarDadosPassageiro(this.props.empresaSelecionada.id)) || validaPerfis([PERFIL_ADMIN]);
    }

    seNaoPossuiPermicaoParaEditarDadosDoPassageiro() {
        return !validaPerfis(getPerfisAlterarDadosPassageiro(this.props.empresaSelecionada.id)) && !validaPerfis([PERFIL_ADMIN]);
    }

    exibirDadosPassageiros(reserva) {
        return (
            <>
                <div className="form-row">
                    <div className="col-12 col-sm-12 col-md-12 text-center">
                        <strong
                            className='ml-2'>{`${reserva.descCidadeOrigem} -> ${reserva.descCidadeDestino}`}</strong>
                    </div>
                </div>
                <div className="form-row">
                    <div className="col-12 col-sm-12 col-md-12 text-center">
                        <strong
                            className='ml-2'>{`Poltrona: ${reserva.passageiroDto.numeroPoltrona} - ${reserva.passageiroDto.descTipoEmissao}`}</strong>
                    </div>
                </div>
                <hr/>
                <div className="form-row">
                    <div className="col-12 col-sm-6 col-md-6 ">
                        <Field name={`numeroCpfPassageiro${reserva.passageiroDto.id}`} type="text"
                                component={renderFieldCpf} label='Número do CPF'
                                validate={[required, validarCPF]}
                                onBlur={e => this.buscarUsuarioPorCpf(e, reserva)}
                                css="form-control"
                                readOnly={this.seNaoPossuiPermicaoParaEditarDadosDoPassageiro()} />
                    </div>
                    <div className="col-12 col-sm-6 col-md-6">
                        <Field name={`nomePassageiro${reserva.passageiroDto.id}`} type="text"
                                component={renderField} label='Nome completo'
                                validate={[required, apenasLetra]}
                                css="form-control" readOnly={this.seNaoPossuiPermicaoParaEditarDadosDoPassageiro()} />
                    </div>
                </div>
                <div className="form-row mt-1">
                    <div className="col-12 col-sm-6 col-md-6">
                        {reserva.passageiroDto.tipoEmissao === 'IDOSO_100'
                        || reserva.passageiroDto.tipoEmissao === 'IDOSO_50'
                            ? <Field name={`dtNascimentoPassageiro${reserva.passageiroDto.id}`} type="text" max={10}
                                        component={renderFieldDataNascimento}
                                        label='Data de nascimento'
                                        validate={[data, idadeMinIdoso, required]}
                                        css="form-control" readOnly={this.seNaoPossuiPermicaoParaEditarDadosDoPassageiro()} />
                            : <Field name={`dtNascimentoPassageiro${reserva.passageiroDto.id}`} type="text" max={10}
                                        component={renderFieldDataNascimento}
                                        label='Data de nascimento'
                                        validate={[required]}
                                        css="form-control" readOnly={this.seNaoPossuiPermicaoParaEditarDadosDoPassageiro()} />
                        }
                    </div>
                    <div className="col-12 col-sm-6 col-md-6">
                        <Field name={`numeroDocumentoFoto${reserva.passageiroDto.id}`} type="text" max={22}
                                component={renderField}
                                label='Número documento com foto'
                                validate={[required, validarRG]}
                                css="form-control" readOnly={this.seNaoPossuiPermicaoParaEditarDadosDoPassageiro()} />
                    </div>                    
                </div>
                <div className="form-row mt-1">
                    <div className="col-12 col-sm-6 col-md-6 mt-1">
                        <label>Código do País</label>
                        <Field name={`ddi${reserva.passageiroDto.id}`}
                            passageiro={reserva.passageiroDto.id}
                            validate={requiredSelect} 
                            component={this.exibirComboDDI.bind(this)} 
                            readOnly={this.seNaoPossuiPermicaoParaEditarDadosDoPassageiro()}/>
                    </div>
                    {this.props.valoresDdiPassageiro.length > 0 && this.props.valoresDdiPassageiro.get(reserva.passageiroDto.id).value === 32 ?  <div className="col-12 col-sm-6 col-md-6">
                       <Field name={`telefone${reserva.passageiroDto.id}`} type="text"
                                component={renderFieldTelefone}
                                css="form-control" label="Telefone" readOnly={this.seNaoPossuiPermicaoParaEditarDadosDoPassageiro()} />
                    </div> : <div className="col-12 col-sm-6 col-md-6 mt-1"><Field name={`telefone${reserva.passageiroDto.id}`} type="text" max={15} component={renderField}
                    validate={[required]} css="form-control" label="Telefone" readOnly={this.seNaoPossuiPermicaoParaEditarDadosDoPassageiro()} /></div>}
                </div>
            </>
        )
    }

    exibirDados() {
        if (this.props.pedido) {
            return (
                this.props.pedido.reservas.map(reserva => <div className="card mb-2 p-2"
                                                               key={`passageiro${reserva.passageiroDto.id}`}>                      
                    {this.exibirDadosPassageiros(reserva)}              
                    {this.exibirCamposAdicionaisDesconto(reserva)}
                    <div className="form-row mt-2">
                        <div className="col-12 col-sm-12 col-md-12">
                            <Field name={`criancaColo${reserva.passageiroDto.id}`} type="checkbox"
                                   component={renderFieldCheck} label="Criança de colo"
                                   css="form-check-input" onChange={() => this.alterarCriancaColo(reserva)}/>
                        </div>
                    </div>
                    {reserva.passageiroDto.criancaDto
                        ? <div>
                            <hr/>
                            <div className="form-row">
                                <div className="col-12 col-sm-6 col-md-6">
                                    <Field name={`nomeCrianca${reserva.passageiroDto.id}`} type="text"
                                           component={renderField}
                                           label='Nome completo da criança' validate={[required, apenasLetra]}
                                           css="form-control"/>
                                </div>
                                <div className="col-12 col-sm-6 col-md-6 ">
                                    <Field name={`cpfCrianca${reserva.passageiroDto.id}`} type="text"
                                           component={renderFieldCpf}
                                           label='Número do CPF criança'
                                           validate={[required, validarCPF]}
                                           css="form-control"/>
                                </div>
                            </div>
                            <div className="form-row mt-1">
                                <div className="col-12 col-sm-6 col-md-6 ">
                                    <Field name={`dtNascimentoCrianca${reserva.passageiroDto.id}`} type="text" max={10}
                                           component={renderFieldDataNascimento}
                                           label='Data de nascimento'
                                           validate={[data, idadeMinCriancaColo, required]}
                                           css="form-control"/>
                                </div>
                                <div className="col-12 col-sm-6 col-md-6 ">
                                    <Field name={`documentoCriancaFoto${reserva.passageiroDto.id}`} type="text" max={22}
                                           component={renderField}
                                           label='Documento com foto/Certidão de nascimento'
                                           validate={[required, validarRG]}
                                           css="form-control"/>
                                </div>
                            </div>
                        </div> : ''
                    }
                </div>)
            )
        }
    }

    render() {
        const {
            handleSubmit, invalid, submitting, pristine
        } = this.props;
        return (
            <div className="modal fade show" role="dialog"
                 id="modalAlterarDadosPassageiro" aria-labelledby="modalAlterarDadosPassageiro" aria-hidden="true"
                 data-backdrop="static">
                <div className="modal-dialog modal-info modal-lg modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h3 className="modal-title">Pedido {this.props.pedido ? this.props.pedido.id : ''}</h3>
                            <button type="button" className="close" data-dismiss="modal"
                                    onClick={() => this.limparFormulario()}
                                    aria-label="Close">
                                <i className="material-icons">
                                    &#xe5cd;
                                </i>
                            </button>
                        </div>
                        <form onSubmit={handleSubmit(this.submit)}>
                            <div className="modal-body">
                                {this.exibirDados()}
                            </div>
                            <div className="modal-footer">
                                <button type="submit" disabled={invalid || submitting || pristine}
                                        className="btn btn-laranja">Salvar
                                </button>                                    
                            </div>
                        </form>
                    </div>
                </div>
            </div>

        )
    }
}

export function mapStateToProps(state) {    
    return {
        empresaSelecionada: state.empresaSelecionada,
        pedido: state.pedido
    }
}

export const mapDispatchToProps = dispatch => (
    bindActionCreators({
        changeFieldValue,
        informarComprovantePagamento,
        alterarCriacaColo,
        alterarDadosPassageiros,
        buscarPassageiroPorCpf
    }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
    form: 'formAlterarDadosPassageiroPedido',
    enableReinitialize: true,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
})(ModalAlteracaoDadosPassageiro));
